export default __webpack_public_path__ + "4765588bf797133c8ce0f57c3f8700f6.png";